<template>
  <div class="pa-2 pb-0">
    <div class="d-flex justify-space-between align-center">
      <v-btn @click.prevent="goToYesterday" size="x-small" variant="flat">&lt; Prev Day</v-btn>

      <v-btn v-if="this.today && this.todayActual && this.today !== this.todayActual" size="x-small" @click="goToToday">go to today</v-btn>

      <v-btn @click.prevent="goToTomorrow" size="x-small" variant="flat">Next Day ></v-btn>
    </div>
  </div>
</template>


<script>
import { getYMDYesterday, getYMDTomorrow } from '@/services/DateServices';
export default {
  computed: {
    today() {
      return this.$store.getters['today'];
    },
    todayActual() {
      return this.$store.getters['todayActual'];
    },
  },
  methods: {
    goToYesterday() {
      if (this.today) {
        const yesterdayDate = getYMDYesterday(this.today);
        window.location.href = `/dash/${yesterdayDate}`;
      }
    },
    goToTomorrow() {
      if (this.today) {
        const tomorrowDate = getYMDTomorrow(this.today);
        window.location.href = `/dash/${tomorrowDate}`;
      }
    },
    goToToday() {
      window.location.href = '/dash/';
    },
  },
};
</script>
